(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.chromotome = {}));
}(this, (function (exports) { 'use strict';

  var blues = {
    name: 'blues',
    colors: [
      '#71CCFF',
      '#2B66FF',
      '#5887FF',
      '#6900BC',
      '#882BFF',
      '#AD00FF',
    ],
  };

  var bygdepride = {
    name: 'bygdepride',
    colors: [
      '#fe69b4',
      '#ff0000',
      '#ff8f00',
      '#fdff00',
      '#008e00',
      '#01c0c1',
      '#400098',
      '#8e018e',
    ],
  };

  var oranges = {
    name: 'oranges',
    colors: [
      '#FF2B2B',
      '#FF2B91',
      '#FF2BF7',
      '#FF7455',
      '#FF902B',
      '#FF922E',
    ],
  };

  var greens = {
    name: 'greens',
    colors: [
      '#009E23',
      '#038400',
      '#04C500',
      '#14FF1E',
      '#3FFFBA',
      '#B3FF53',
    ],
  };

  var paint = {
    name: 'paint',
    colors: [
      '#FFDCC8',
      '#82C1E4',
      '#DFD0FE',
      '#DAEDFF',
      '#B1F8B8',
      '#A1D8FF',
      '#FFDAA1',
      '#FFA1A1',
    ],
  };

  var pastel = {
    name: 'pastel',
    colors: [
      '#C3FFAE',
      '#CBFCFF',
      '#D0FFF9',
      '#D4E5FF',
      '#D6FFD6',
      '#D7FFE2',
      '#E8CAFF',
      '#E8FFCB',
      '#FEFFC2',
      '#FFC6BE',
      '#FFCBFD',
      '#FFDADA',
      '#FFDDBE',
      '#FFE8EC',
    ],
  };

  var purples = {
    name: 'purples',
    colors: [
      '#864EFF',
      '#9B009E',
      '#BD00FF',
      '#FF006B',
      '#FF14E8',
      '#FF5391',
    ],
  };

  var reds = {
    name: 'reds',
    colors: [
      '#CB1F1F',
      '#CC0404',
      '#FF008A',
      '#FF1414',
      '#FF1717',
      '#FF613F',
    ],
  };

  var skilnad = {
    name: 'skilnad',
    colors: [
      '#2B66FF',
      '#2BCCFF',
      '#90FFEB',
      '#FF372B',
      '#FF902B',
      '#FFC32B',
    ],
  };

  const categories = {
    basics: ['blues', 'greens', 'oranges', 'purples', 'reds'],
    galaxy: ['blues', 'greens', 'oranges', 'purples', 'reds', 'skilnad'],
  };

  const colorSets = [
    blues,
    bygdepride,
    greens,
    oranges,
    paint,
    pastel,
    purples,
    reds,
    skilnad,
  ];

  function getCategory(name) {
    try {
      return categories[name]
    } catch(_) {
      return null
    }
  }

  function getSet(name) {
    const colorSet = colorSets.find(s => s.name == name);
    if (typeof colorSet === 'undefined') {
      return getRandomColors()
    }
    return colorSet
  }

  function getColors(set, ...sets) {
    let colors = [];
    colors = getSet(set).colors;
    if (sets[0]) {
      sets.forEach(s => colors = colors.concat(getSet(s).colors));
    }
    return colors
  }

  function getRandomColors(selection) {
    let colors = [];
    if (selection) {
      selection.forEach(sl => colors.push(getSet(sl)));
      return colors[Math.floor(Math.random() * colors.length)].colors
    }
    return colorSets[Math.floor(Math.random() * colorSets.length)].colors
  }

  function getRandomColorsFromCategory(category) {
    const selected = getCategory(category);
    return getRandomColors(selected)
  }

  exports.getCategory = getCategory;
  exports.getColors = getColors;
  exports.getRandomColors = getRandomColors;
  exports.getRandomColorsFromCategory = getRandomColorsFromCategory;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
